import React from 'react'
import { useTranslation } from 'react-i18next'
import { BOARDS, FOLDERS } from '../../../constants'
import Button from '../../common/Button'
import Icon from 'common/components/Icon'
import Text from 'common/components/Text'
import Toolbar from '../../common/Toolbar'

const CreateButton = ({ children, ...props }) => (
  <Toolbar>
    <Button stretch {...props}>
      <Icon icon="plus" />
      <Text>{children}</Text>
    </Button>
  </Toolbar>
)
const AuthButton = ({ children, ...props }) => (
  <Toolbar>
    <Button stretch {...props}>
      <Text>{children}</Text>
    </Button>
  </Toolbar>
)

export const SidebarBottomBar = ({
  folderId,
  canCreate,
  createBoard,
  createFolder,
  anon,
  section,
  hasMouse
}) => {
  const { t } = useTranslation()

  if (anon)
    return (
      <>
        <AuthButton to="#signin">{t('auth.signin')}</AuthButton>
        <AuthButton to="#signup">{t('auth.signup')}</AuthButton>
      </>
    )

  return (
    <>
      {hasMouse ? (
        <>
          {(folderId || section === BOARDS) && (
            <CreateButton
              disabled={!canCreate}
              onClick={() => canCreate && createBoard(folderId)}
            >
              {t('globalNav.createBoard')}
            </CreateButton>
          )}
          {(folderId || section === FOLDERS) && (
            <CreateButton
              disabled={!canCreate}
              onClick={() => canCreate && createFolder(folderId)}
            >
              {t('globalNav.createFolder.button')}
            </CreateButton>
          )}
        </>
      ) : (
        <CreateButton onClick={() => alert(t('globalNav.noTouchCreate'))}>
          {t('globalNav.createBoardFolder')}
        </CreateButton>
      )}
    </>
  )
}

export default SidebarBottomBar
